export default "__VITE_ASSET__BqkryZzW__"